import {gsap} from "gsap/gsap-core";
import {inject, injectable} from "inversify";
import {Sprite} from "pixi.js-legacy";
import {View} from "@dp-instant/2d";
import {WaitAction} from "@dp-instant/core";

@injectable()
export class TutorialFingerView extends View {
    @inject("finger.svg")
    protected sprite: Sprite;

    public onAdded(): void {
        this.sprite.anchor.set(0.5, 20 / this.sprite.height);
        this.sprite.position.set(0, 0);
        this.addChild(this.sprite);
        super.onAdded();
    }

    public async hold(duration = 0.5): Promise<void> {
        this.cancelTweens();
        const w = this.sprite.width * 0.4; // rotation size
        const rotation = -Math.tan(w / this.sprite.height);
        const scale = 0.9;
        await new Promise(onComplete => {
            gsap.timeline()
                .to(this.sprite, {
                    // x: -w * .5,
                    y: w * scale,
                    duration,
                    rotation
                })
                .to(this.sprite.scale, {x: scale, y: scale, duration, onComplete}, 0);
        });
    }

    public async release(duration = 0.5): Promise<void> {
        this.cancelTweens();
        await new Promise(onComplete => {
            gsap.timeline()
                .to(this.sprite, {x: 0, y: 0, duration, rotation: 0})
                .to(this.sprite.scale, {x: 1, y: 1, duration, onComplete}, 0);
        });
    }

    private cancelTweens(): void {
        gsap.killTweensOf(this.sprite);
        gsap.killTweensOf(this.sprite.scale);
    }

    public async tap(time = 200): Promise<void> {
        await this.hold();
        await WaitAction.ms(time);
        await this.release();
        await WaitAction.ms(time);
    }
}
